import React from 'react';
import { useTranslation } from 'react-i18next';
import { Divider, Flex, Popover, Typography } from 'antd';
import { numberFormatter } from 'shared/utils/numbers/formatter.ts';
import { CURRENCY_SIGN, ECurrency } from 'types/currencies.ts';
import styles from './debt-breakdown-popover.module.scss';
import type { IDebtBreakdownPopoverProps } from './types.ts';

const { Text } = Typography;
const EUR_SIGN = CURRENCY_SIGN[ECurrency.EUR];

export const DebtBreakdownPopover: React.FC<IDebtBreakdownPopoverProps> = (props) => {
  const { debt, children } = props;
  const { t } = useTranslation();

  if (!debt) return children;

  const content = (
    <div className={styles.breakdown}>
      <Flex justify='space-between'>
        <Text>{t('client:invoices')}</Text>
        <Text strong>
          {numberFormatter(debt.invoiceDebt)} {EUR_SIGN}
        </Text>
      </Flex>
      <Flex justify='space-between'>
        <Text>{t('client:active_orders')}</Text>
        <Text strong>
          {numberFormatter(debt.orderDebt)} {EUR_SIGN}
        </Text>
      </Flex>
      <Flex justify='space-between'>
        <Text>{t('client:active_warehouse_tasks')}</Text>
        <Text strong>
          {numberFormatter(debt.warehouseTaskDebt)} {EUR_SIGN}
        </Text>
      </Flex>
      <Divider className={styles.divider} />
      <Flex justify='space-between'>
        <Text strong>{t('client:total')}</Text>
        <Text strong>
          {numberFormatter(debt.totalDebt)} {EUR_SIGN}
        </Text>
      </Flex>
    </div>
  );

  return (
    <Popover title={t('client:debt_breakdown')} content={content} placement='bottomRight' trigger='hover'>
      {children}
    </Popover>
  );
};
